import React from 'react';
function NavWrap(props) {
  const {
    children,
    ...otherProps
  } = props;
  delete otherProps.activeKey;
  delete otherProps.activeHref;
  return /*#__PURE__*/React.createElement("li", Object.assign({
    className: "display-flex align-items-center"
  }, otherProps), children);
}
export default NavWrap;